import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ViewSizeGuide } from '@yme/assets/icons';
import { NA_VALUE } from '@yme/common/constants';
import { FasletSizeWidget } from '@yme/pdp-components/Faslet';
import { SHOP_ID } from '@yme/pdp-components/Faslet/constants';
import { getIsWidgetShown } from '@yme/pdp-components/Faslet/selectors';
import { getProductCardLabels, getProductValueByOption } from '@yme/pdp-components/ProductCard';
import { SelectSize } from '@yme/pdp-components/ProductCard/components/ProductFilter/SelectSize';
import { SizeGuideButton } from '@yme/pdp-components/ProductCard/components/SizeGuideButton/SizeGuideButton';
import { SIZE_KEY } from '@yme/selectors/constants';
import { getProductDetails, getProductVariantsByColor } from '@yme/selectors/products';
import { RegularLinkLevel1, RegularTextLevel3 } from '@yme/tokens/typography';
import { useSelectNewValue } from '../useSelectNewValue';
import { SIZE_GUIDE_BUTTON_DELAY, YAMALUBE } from './constants';
import { getSizesValue, sortArray } from './helpers';
export function SelectAccessorySize({ productFilterOptions, variantsOfProduct, currentProduct, sizeGuideAssetPath, isApparel, fasletModel, }) {
    const [shouldRenderButton, setShouldRenderButton] = useState(false);
    const { data } = useSelector(getProductDetails);
    const allProductSizeValues = useSelector(getProductValueByOption(SIZE_KEY));
    const productVariantsByColor = useSelector(getProductVariantsByColor);
    const { product_size_label: sizeLabel, partsAccessoriesMerch_weight_label: weightLabel, productCard_viewSizeGuide_link: viewSizeGuideLabel, } = useSelector(getProductCardLabels);
    const isWidgetShown = useSelector(getIsWidgetShown);
    const { size, sku, colorItemIndex = 0 } = productFilterOptions;
    const { selectNewValue } = useSelectNewValue({
        size,
        sku,
        variantsOfProduct,
    });
    const filteredSizes = allProductSizeValues.filter((size) => size !== NA_VALUE);
    const isNoSizes = filteredSizes.length === 0;
    const isYamalube = Boolean(data?.name.toLowerCase().includes(YAMALUBE));
    const allAreNumbers = filteredSizes.every((item) => !isNaN(Number(item)));
    const { fasletShoppingId = SHOP_ID, labels } = fasletModel || {};
    const productVariantsByIndex = productVariantsByColor[colorItemIndex];
    const possibleOptions = productVariantsByColor && productVariantsByIndex?.sizePossibleOptions
        ? productVariantsByIndex.sizePossibleOptions
        : filteredSizes;
    const sortedFilteredSizes = allAreNumbers ? sortArray(filteredSizes) : filteredSizes;
    const formattedAllProductSizeValues = getSizesValue(sortedFilteredSizes, isYamalube);
    const formattedPossibleOptions = getSizesValue(possibleOptions, isYamalube);
    const isShowSizeGuide = !isYamalube && isApparel;
    useEffect(() => {
        if (isShowSizeGuide && !isWidgetShown) {
            const timer = setTimeout(() => {
                setShouldRenderButton(true);
            }, SIZE_GUIDE_BUTTON_DELAY); // TODO: remove when Faslet widget won't needed
            return () => clearTimeout(timer);
        }
        else {
            setShouldRenderButton(false);
        }
    }, [isShowSizeGuide, isWidgetShown]);
    if (isNoSizes) {
        return null;
    }
    return (React.createElement(SelectSize, { productFilterOptions: productFilterOptions, variantsOfProduct: variantsOfProduct, allOptions: formattedAllProductSizeValues, possibleOptions: formattedPossibleOptions, allProductSizeValues: filteredSizes, productVariantsByColor: productVariantsByColor, onSelectNewValue: selectNewValue, isSquareButton: !isYamalube, allowClickOnDisabled: true },
        React.createElement(RegularTextLevel3, { weight: 500 },
            isYamalube ? weightLabel : sizeLabel,
            ":"),
        shouldRenderButton && (React.createElement(SizeGuideButton, { asComponent: RegularLinkLevel1, viewSizeGuideLabel: viewSizeGuideLabel, sizeGuideAssetPath: sizeGuideAssetPath, viewSizeGuide: ViewSizeGuide })),
        React.createElement(FasletSizeWidget, { shopId: fasletShoppingId, sku: sku, buttonText: labels?.faslet_viewSizeButton_text, alternateButtonText: labels?.faslet_yourSizeButton_text, currentProduct: currentProduct, products: variantsOfProduct, onSelectSize: selectNewValue, currentSize: size })));
}
SelectAccessorySize.displayName = 'SelectAccessorySize_Component';
